import React, { Dispatch, FC, SetStateAction } from "react"
import { CalendarDaysIcon, BookOpenIcon } from "@heroicons/react/24/outline"
import { Quotes } from "@/lib/types"

type Props = {
  defaultVal: Quotes
  setQuote: Dispatch<SetStateAction<Quotes>>
  listingData: {
    usersAndQuoteCounts: {
      firstName: string
      lastName: string
      quoteCount: string
    }[]
  }
}

export const QuoteCount: FC<Props> = (props) => {
  return (
    <div className="dark:bg-primary-1 bg-white dark:border-2 dark:border-secondary-11 rounded-lg">
      <div className="flex gap-x-4 justify-between px-5 pt-3 pb-3 sm:flex-nowrap flex-wrap">
        <div>
          <div className="flex items-center gap-x-2">
            <CalendarDaysIcon className="w-5 h-5 dark:text-primary-12 text-light-1" />
            <h1 className="2xl:text-lg text-base dark:text-primary-10 text-light-2">
              Date Range
            </h1>
          </div>
          <div className="flex justify-start pl-5">
            <select
              onChange={(e) =>
                props.setQuote((prevStats) => ({
                  ...prevStats,
                  months: e.target.value,
                }))
              }
              className="bg-transparent outline-none dark:text-primary-11 text-light-1 text-sm pt-1"
            >
              <option className="dark:bg-primary-1" value="All Time">
                All Time
              </option>
              <option className="dark:bg-primary-1" value="1 Day Ago">
                1 Day Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Week Ago">
                1 Week Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Month Ago">
                1 Month Ago
              </option>
              <option className="dark:bg-primary-1" value="6 Months Ago">
                6 Months Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Year Ago">
                1 Year Ago
              </option>
            </select>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-x-2">
            <BookOpenIcon className="w-5 h-5 dark:text-primary-12 text-light-1" />
            <h1 className="2xl:text-lg text-base dark:text-primary-10 text-light-2">
              Scope
            </h1>
          </div>
          <div className="flex justify-start pl-5">
            <select
              onChange={(e) =>
                props.setQuote((prevStats) => ({
                  ...prevStats,
                  role: e.target.value,
                }))
              }
              className="bg-transparent outline-none dark:text-primary-11 text-light-1 text-sm pt-1"
            >
              <option className="dark:bg-primary-1" value="CUSTOMER">
                Customer
              </option>
              <option className="dark:bg-primary-1" value="SALESREP">
                Sales Rep
              </option>
              <option className="dark:bg-primary-1" value="Company">
                Company
              </option>
            </select>
          </div>
        </div>
      </div>
      <>
        <div className="flex justify-between text-lg font-medium border-y-2 dark:border-secondary-11 dark:text-primary-10 text-light-3 text-md px-5 pt-3 pb-2">
          <span>User</span>
          <span>Quotes</span>
        </div>
        <div className="h-52 overflow-y-auto divide-y-2 dark:divide-secondary-11">
          {props.listingData.usersAndQuoteCounts.map((e, i) => (
            <div
              key={i}
              className="flex justify-between text-sm text-primary-17 px-5 pt-3 pb-2"
            >
              <p>
                {e.firstName} {e.lastName}
              </p>
              <p className="dark:text-primary-8 text-light-1">{e.quoteCount}</p>
            </div>
          ))}
        </div>
      </>
    </div>
  )
}
